export const Language = {
    en: 'en',
    ...(process.env.IS_CUSTOM_COMPANY ? {} : { ru: 'ru' }),
};

export const Languages = Object.values(Language);

export const EFB_DEFAULT_LANGUAGE = 'en';
